import React from 'react';

const LayoutDefault = ({ children }) => (
  <>
    {children}
  </>
);

export default LayoutDefault;  